//@ts-nocheck
import { useEffect, useContext } from "react"
import AppContext from "../context/AppContext";
import { setTokenToLocalStorage, stripTokenFromUrl } from "./authJwt";
import { COGNITO_LOGIN_URL } from "./authConfig";
import { clearReauthGuard } from "../api/api";

export function AuthProvider({ children }) {

    const { setUsername, setUserGroup, userGroups, setUserGroups } = useContext(AppContext);

    useEffect(() => {
        // Cognito hosted-login URL (NP vs Prod) is defined once in authConfig.ts
        // and shared with api.tsx's 401 re-auth handling.
        let url = COGNITO_LOGIN_URL;

        const authenticateUser = async () => {

            const authResponse: JwtResponse = await setTokenToLocalStorage();

            if (authResponse.type === "ERROR") {
                console.log(authResponse.type);
                console.log(authResponse.message);
                setUserGroup("NoAuth");
                setTimeout(() => {
                    window.location.href = url;
                }, 3000)

            } else if (authResponse.type === "SUCCESS") {
                console.log(authResponse.type);
                // Auth succeeded: reset the re-auth loop guard so a genuine
                // future token expiry can trigger a fresh login redirect again.
                clearReauthGuard();
                setUsername(authResponse.username);
                setUserGroups(authResponse.group)
            }
        }

        //Uncomment the line below for deployment builds
        authenticateUser();

       //Uncomment lines below for local dev:
       //const successResponse: JwtResponse = {
       //     type: "SUCCESS",
       //    username: "okta_joseph.beltran@dish.com ",
       //    group: ["APP-CampaignManager-Prod_Administrator"]
       // };
       //group: ["APP-CampaignManager-NP_EmailSMSPSHReadOnly_DBS", "APP-CampaignManager-NP_Administrator", "APP - CampaignManager - NP_OBAgentAutoMessageContentMgr", "APP-CampaignManager-NP_EmailSMSPSHContentMgr_OnTech", "APP-CampaignManager-NP_Administrator", "APP-CampaignManager-NP_OBAgentAutoMessageContentMgr", "APP-CampaignManager-NP_EmailSMSPSHContentMgr_OnTech"]
       //setUserGroups(successResponse.group)
       //setUsername(successResponse.username);

    },[])

    useEffect(() => {
    }, [userGroups])

    if (userGroups?.some((str) => str.includes("CampaignManager"))) {
        stripTokenFromUrl();
        return (
        <div>
            {children}
        </div>
    )
    } else {
        return (
            <h1>Please wait for authentication...</h1>
        )
    }
}